import { gql, useMutation } from '@apollo/client';

const QUESTIONNAIRE_DOWNLOAD_PDF_V2 = gql`
  mutation QuestionnaireDownloadPdfV2($id: String!, $token: String, $fileName: String) {
    questionnaireDownloadPdfV2(id: $id, token: $token, fileName: $fileName) {
      mimeType
      fileName
      fileBase64
    }
  }
`;

export interface QuestionnaireDownloadPdfV2Input {
  id: string;
  token?: string;
  fileName?: string;
}

export interface QuestionnaireDownloadPdfV2Result {
  questionnaireDownloadPdfV2: {
    mimeType: string;
    fileName: string;
    fileBase64: string;
  };
}

/**
 * Hook for downloading questionnaire as PDF using the new HTML-first approach.
 *
 * This mutation uses locally rendered HTML (with snippets and translations) converted
 * to PDF via LibreOffice, instead of relying on legalOS DOCX rendering.
 *
 * Supports anonymous access via token (for signature requests, document sharing).
 *
 * @example
 * const [downloadPdf, { loading }] = useQuestionnaireDownloadPdfV2Mutation();
 * downloadPdf({ variables: { id: localQuestionnaireId } });
 */
export function useQuestionnaireDownloadPdfV2Mutation() {
  return useMutation<QuestionnaireDownloadPdfV2Result, QuestionnaireDownloadPdfV2Input>(QUESTIONNAIRE_DOWNLOAD_PDF_V2);
}
